export const viewTypes: Record<string, string> = {
  DAY: 'day',
  WEEK: 'week',
  MONTH: 'month',
}
